'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _setDisplayName = require('recompose/setDisplayName');

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleWrapperFunction = function styleWrapperFunction(defaultStyle) {
  var overrideStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof defaultStyle === 'function') {
    return function () {
      return (0, _deepmerge2.default)(defaultStyle.apply(undefined, arguments), typeof overrideStyle === 'function' ? overrideStyle.apply(undefined, arguments) : overrideStyle);
    };
  } else {
    return (0, _deepmerge2.default)(defaultStyle, overrideStyle);
  }
};

var merge = function merge(defaultStyleSheet) {
  var overrideStyleSheet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(defaultStyleSheet).reduce(function (result, key) {
    return _extends({}, result, _defineProperty({}, key, styleWrapperFunction(defaultStyleSheet[key], overrideStyleSheet[key])));
  }, {});
};

exports.default = function (getDefaultStyleSheet) {
  return function (Target) {
    return (0, _compose2.default)((0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(Target, 'withStyleSheetOverride')))(function (_ref) {
      var _ref$getStyleSheet = _ref.getStyleSheet,
          getStyleSheet = _ref$getStyleSheet === undefined ? function () {
        return {};
      } : _ref$getStyleSheet,
          props = _objectWithoutProperties(_ref, ['getStyleSheet']);

      return _react2.default.createElement(Target, _extends({ styleSheet: merge(getDefaultStyleSheet(props), getStyleSheet(props)) }, props));
    });
  };
};